export default __webpack_public_path__ + "static/media/nineDour2.1b541d44.png";